import { CheckCircleIcon } from "@heroicons/react/20/solid";
import { FC } from "react";
import _ from "lodash";
import clsx from "clsx";

interface Option {
  value: string;
  label: string;
  description: string;
}

interface RegularSelectInputProps {
  id: string;
  label: string;
  hideLabel?: boolean;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  values: any;
  handleChange: any;
  handleBlur?: any;
  errors?: any;
  touched?: any;
  defaultValue?: string;
  options: Option[];
  description?: string;
  columns?: number;
}

const RadioSelectInput: FC<RegularSelectInputProps> = ({
  id,
  disabled,
  required,
  options,
  label,
  values,
  handleChange,
  handleBlur,
  touched,
  errors,
  columns = 2,
}) => {
  const columnsClass = `sm:grid-cols-${columns}`;

  return (
    <fieldset>
      <legend className="block text-sm font-medium text-primary">
        {label} {required ? <span className="text-red-600">*</span> : ""}
      </legend>
      <div
        className={clsx(
          "mt-6 grid grid-cols-1 gap-y-6 sm:gap-x-4",
          columnsClass
        )}
      >
        {options?.map((option) => (
          <label
            key={option.value}
            aria-label={option.label}
            aria-description={`${option.description}`}
            className="group relative flex rounded-lg border border-black/50 bg-white p-4 has-[:checked]:bg-primary-500/10 has-[:disabled]:bg-gray-800 has-[:disabled]:opacity-25 has-[:checked]:outline has-[:focus-visible]:outline has-[:checked]:outline-2 has-[:focus-visible]:outline-[3px] has-[:checked]:-outline-offset-2 has-[:focus-visible]:-outline-offset-1 has-[:checked]:outline-primary-600"
          >
            <input
              name={id}
              id={`${id}-${option.value}`}
              value={option.value}
              checked={_.get(values, id, "") === option.value}
              onChange={handleChange}
              onBlur={handleBlur}
              disabled={disabled}
              required={required}
              type="radio"
              className="absolute inset-0 appearance-none hidden focus:outline focus:outline-0"
            />
            <div className="flex-1">
              <span className="block text-sm font-medium text-primary">
                {option.label}
              </span>
              <span className="mt-1 block text-sm text-gray-400">
                {option.description}
              </span>
            </div>
            <CheckCircleIcon
              aria-hidden="true"
              className="invisible size-5 text-primary-600 group-has-[:checked]:visible"
            />
          </label>
        ))}
      </div>
      {_.get(errors, id) && _.get(touched, id) && (
        <p className="mt-2 text-sm text-red-600" id={`${id}-error`}>
          {_.get(errors, id)}
        </p>
      )}
    </fieldset>
  );
};

export default RadioSelectInput;
